import React from "react";
import { useSeller } from "../context/SellerContext";
import IntroPage from "./IntroPage";
import SellerShop from "./SellerShop";

function Home({ cartCount, addToCart }) {
  const { isSellerSite, loading } = useSeller();

  if (loading) {
    return (
      <div className="home-loading" style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        flexDirection: 'column'
      }}>
        <div className="loading-spinner"></div>
      </div>
    );
  }

  // 판매자 서브도메인으로 접속한 경우 판매자 샵을 보여줌
  if (isSellerSite) {
    return <SellerShop cartCount={cartCount} addToCart={addToCart} />;
  }

  // 메인 도메인(www 포함)으로 접속한 경우 서비스 소개 페이지를 보여줌
  return <IntroPage />;
}

export default Home;
